/* =============================================================================
   PILLOW CLUB — Contrôleur du configurateur
   Relie l'interface au moteur d'aperçu. Aucune dépendance.
   ========================================================================== */
(function () {
  'use strict';

  var B = window.PillowClubBroderie;
  if (!B) return;                       // sans le moteur, le formulaire reste utilisable

  var $ = function (s) { return document.querySelector(s); };

  /* Certains éléments n'existent que dans la démo (panneau de débogage) ou que
     dans le thème. Un addEventListener sur null lève, et comme tout le
     démarrage tient dans un seul bloc, l'exception emporte le chargement de
     l'image de fond : l'aperçu reste vide jusqu'à ce que le client clique une
     couleur, dont le gestionnaire avait été enregistré plus tôt.
     Tout accès à un élément facultatif passe donc par ici. */
  function siPresent(selecteur, action) {
    var el = document.querySelector(selecteur);
    if (el) { try { action(el); } catch (e) { console.warn('[Pillow Club] ' + selecteur, e); } }
    return el;
  }

  /* La section Liquid dépose sa configuration dans #pillowclub-config. En son
     absence — démo autonome ouverte depuis le disque — on retombe sur les
     valeurs ci-dessous. */
  var CFG = null;
  var noeudCfg = document.getElementById('pillowclub-config');
  if (noeudCfg) { try { CFG = JSON.parse(noeudCfg.textContent); } catch (e) { console.error('pillowclub-config illisible', e); } }
  var MODE_DEMO = !CFG;

  var MODELE_DEFAUT = {
    nom: 'Taie d’oreiller brodée',
    prixBase: 45,
    prixPersonnalisation: 0,
    prixCadeau: 0,
    /* 780 mm = largeur hors tout de la taie, volant compris. C'est bien
       cette largeur-là qui occupe largeurTaieFraction de l'image : s'y
       tromper fausse le mm/pixel, donc l'alerte de finesse de trait. */
    largeurReelleMm: 840,
    largeurTaieFraction: 0.82,
/* Relevé sur pillowclub-taie-blanc-plat.jpg. La taie occupe x 0,093 -> 0,915
       et y 0,246 -> 0,746 de l'image ; le volant fait 0,060 de la hauteur, donc
       le panneau court de x 0,168 -> 0,840 et y 0,306 -> 0,686. Les deux ancres
       sont posées À L'INTÉRIEUR de ce cadre — une ancre hors taie dessinerait
       la broderie sur le fond. */
    emplacements: {
      'panneau':     { x: 0.500, y: 0.500, largeurMax: 0.46, hauteurMm: 22, rotation: 0, inclinaison: 0, aplatissement: 1 },
      'haut-gauche': { x: 0.310, y: 0.360, largeurMax: 0.26, hauteurMm: 22, rotation: 0, inclinaison: 0, aplatissement: 1 },
      'haut-droit':  { x: 0.700, y: 0.360, largeurMax: 0.26, hauteurMm: 22, rotation: 0, inclinaison: 0, aplatissement: 1 }
    }
  };

  /* Teintes relevées par échantillonnage au centre du panneau de chaque
     photo, pas choisies à l'œil : la pastille doit dire la vérité du tissu. */
  var COLORIS_DEFAUT = [
    { id: 'blanc', nom: 'Blanc', hex: '#F0F0F4' },
    { id: 'rose', nom: 'Rose poudré', hex: '#DABDBC' },
    { id: 'bleu', nom: 'Bleu ciel', hex: '#C4D2E1' },
    { id: 'sauge', nom: 'Sauge', hex: '#B9C2B5' }
  ];

  var nb = function (v, repli) { v = parseFloat(v); return isFinite(v) && v > 0 ? v : repli; };

  var MODELE = CFG ? {
    nom: CFG.produit.titre || MODELE_DEFAUT.nom,
    prixBase: nb(CFG.produit.prixBase, MODELE_DEFAUT.prixBase),
    prixPersonnalisation: 0,
    prixCadeau: 0,
    identifiant: CFG.produit.modele || 'produit',
    largeurReelleMm: nb(CFG.geometrie && CFG.geometrie.largeurReelleMm, 840),
    largeurTaieFraction: nb(CFG.geometrie && CFG.geometrie.largeurTaieFraction, 0.82),
    emplacements: (CFG.emplacements && Object.keys(CFG.emplacements).length)
      ? CFG.emplacements : MODELE_DEFAUT.emplacements,
    formats: CFG.formats || null
  } : MODELE_DEFAUT;

  /* ------------------------------------------------------------- Formats */
  /* Un 50 × 70 et un 65 × 65 ne sont pas la même photo, et surtout pas la
     même géométrie : le panneau carré n'a ni les mêmes proportions ni le
     même angle haut. Chaque format porte donc sa propre calibration ET sa
     propre image. Sans ça, choisir « 65 × 65 » laissait l'aperçu montrer un
     rectangle — l'aperçu mentait sur ce qu'on achetait.

     Le format est reconnu par la VALEUR de l'option produit, pas par sa
     position : renommer l'option dans l'admin ne doit pas faire retomber le
     carré sur la géométrie du rectangle en silence. */
  if (!MODELE.formats) {
    MODELE.formats = { rect: {
      valeurOption: null,
      largeurReelleMm: MODELE.largeurReelleMm,
      largeurTaieFraction: MODELE.largeurTaieFraction,
      emplacements: MODELE.emplacements
    } };
  }

  function cleFormat() {
    var f = MODELE.formats;
    for (var k in f) {
      if (f[k].valeurOption && normaliser(f[k].valeurOption) === normaliser(etat.option2)) return k;
    }
    return f.rect ? 'rect' : Object.keys(f)[0];
  }
  function formatActif() { return MODELE.formats[cleFormat()]; }

  /* Les coloris viennent des VARIANTES du produit, pas des blocs de section.
     Les blocs n'apportent que la photo et la pastille de chaque coloris.
     Sans ça, le sélecteur et le catalogue divergent : le client choisit une
     couleur qui n'existe pas, ou en commande une autre que celle affichée. */
  var OPTIONS   = (CFG && CFG.options)   || [];
  var VARIANTES = (CFG && CFG.variantes) || [];

  function normaliser(v) {
    return String(v || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }

  var COLORIS;
  if (OPTIONS.length && VARIANTES.length) {
    var parBloc = {};
    ((CFG && CFG.coloris) || []).forEach(function (b) { parBloc[normaliser(b.nom)] = b; });
    /* Les coloris viennent des variantes Shopify — c'est elles qui font foi
       pour le panier. Le bloc de thème n'apporte que l'habillage : teinte,
       photos, correction de cadrage. Tout ce que le bloc porte doit être
       recopié ici, sinon il est silencieusement perdu pour les produits à
       variantes, et seulement pour eux. */
    COLORIS = OPTIONS[0].valeurs.map(function (valeur) {
      var b = parBloc[normaliser(valeur)] || {};
      return { id: normaliser(valeur), nom: valeur, valeurOption: valeur,
               hex: b.hex || '#C8B79C',
               image: b.image || null,
               imageCarre: b.imageCarre || null,
               imageVerso: b.imageVerso || null,
               dx: b.dx || 0, dy: b.dy || 0,
               dxVerso: b.dxVerso || 0, dyVerso: b.dyVerso || 0 };
    });
  } else {
    COLORIS = (CFG && CFG.coloris && CFG.coloris.length) ? CFG.coloris : COLORIS_DEFAUT;
  }

  var OPTION2 = OPTIONS.length > 1 ? OPTIONS[1] : null;

  /* Les cartes de collection éclatées par coloris pointent vers
     ?variant=<id>. Sans cette lecture, quelqu'un qui clique « Bordeaux »
     atterrit sur le sable : la grille par couleur deviendrait un piège. */
  function varianteDeLUrl() {
    if (!VARIANTES.length || typeof URLSearchParams === 'undefined') return null;
    var demande;
    try { demande = new URLSearchParams(window.location.search).get('variant'); }
    catch (e) { return null; }
    if (!demande) return null;
    for (var i = 0; i < VARIANTES.length; i++) {
      if (String(VARIANTES[i].id) === String(demande)) return VARIANTES[i];
    }
    return null;
  }

  var departVariante = varianteDeLUrl();
  var departColoris = COLORIS[0];
  var departOption2 = OPTION2 ? OPTION2.valeurs[0] : null;
  if (departVariante) {
    var corr = COLORIS.filter(function (c) {
      return normaliser(c.valeurOption) === normaliser(departVariante.options[0]);
    })[0];
    if (corr) departColoris = corr;
    if (OPTION2 && departVariante.options[1]) departOption2 = departVariante.options[1];
  }

  var champTouche = false;    // pas de message d'erreur tant qu'on n'a rien saisi

  var etat = {
    coloris: departColoris.id, option2: departOption2, texte: '', style: 'script',
    fil: 'rouge', emplacement: 'panneau',
    cadeau: false
  };

  var canvas = $('#apercu');

  /* Le theme editor expose la hauteur des lettres en MILLIMÈTRES : c'est
     l'unité dont parle l'atelier, et c'est celle qui décide si le trait reste
     brodable. Le moteur raisonne en fraction de la hauteur d'image.
     La conversion dépend des dimensions RÉELLES du canevas — lesquelles ne
     sont connues qu'une fois la photo chargée et redimensionnée. On la refait
     donc après chaque chargement de fond, et pas une seule fois au départ. */
  /* Les ancres du gabarit sont exprimées pour un cadrage de référence. Deux
     photos d'un même produit ne cadrent jamais tout à fait pareil — sur une
     pièce haute et étroite comme un peignoir, deux pour cent de dérive
     suffisent à sortir le texte du vêtement. Chaque coloris peut donc
     corriger le tir avec un décalage, appliqué ici et jamais dans le gabarit. */
  var ANCRES_SOURCE = JSON.parse(JSON.stringify(
    (function () { var o = {}; for (var k in MODELE.formats) o[k] = MODELE.formats[k].emplacements; return o; })()
  ));

  function recalibrer() {
    var kf = cleFormat(), F = MODELE.formats[kf];
    var mmParPixel = F.largeurReelleMm / (F.largeurTaieFraction * canvas.width);
    apercu.mmParPixel = mmParPixel;
    apercu.ancres = F.emplacements;
    var c = coloris(etat.coloris) || {};
    var verso = (faceChargee === 'verso');
    var dx = (verso ? c.dxVerso : c.dx) || 0;
    var dy = (verso ? c.dyVerso : c.dy) || 0;
    for (var cle in F.emplacements) {
      var a = F.emplacements[cle], src = ANCRES_SOURCE[kf][cle];
      if (!a || !src) continue;
      a.x = src.x + dx;
      a.y = src.y + dy;
      if (a.hauteurMm != null) a.hauteur = a.hauteurMm / (mmParPixel * canvas.height);
    }
    return mmParPixel;
  }

  /* Recto ou verso : un emplacement peut demander l'autre face du produit,
     auquel cas il faut recharger la photo et pas seulement déplacer l'ancre. */
  function faceDe(cle) {
    var a = formatActif().emplacements[cle];
    return (a && a.face) || 'recto';
  }
  function imageDe(coloris, face) {
    if (cleFormat() === 'carre' && coloris.imageCarre) return coloris.imageCarre;
    return (face === 'verso' && coloris.imageVerso) ? coloris.imageVerso : coloris.image;
  }
  var faceChargee = 'recto';

  var apercu = new B.ApercuBroderie(canvas, {
    ancres: formatActif().emplacements,
    mmParPixel: formatActif().largeurReelleMm / (formatActif().largeurTaieFraction * canvas.width)
  });

  /* ------------------------------------------------- taie de remplacement */
  /* Aplat généré par le code. Il sert quand la photo d'un coloris manque, et
     dans la démo isolée. Il reproduit exactement le cadrage de la photo
     maîtresse — sans ça, l'aperçu de repli placerait la broderie ailleurs
     que l'aperçu principal, et l'aperçu mentirait. */

  function fabriquerTaie(hex) {
    var carre = cleFormat() === 'carre';
    var L = 1200, H = 1500;
    var c = document.createElement('canvas'); c.width = L; c.height = H;
    var x = c.getContext('2d');

    x.fillStyle = '#F8F7F4'; x.fillRect(0, 0, L, H);           // fond papier

    var x0 = (carre ? 0.100 : 0.093) * L, x1 = (carre ? 0.900 : 0.915) * L;
    var y0 = (carre ? 0.180 : 0.246) * H, y1 = (carre ? 0.820 : 0.746) * H;
    var lt = x1 - x0, ht = y1 - y0;

    x.save();
    x.shadowColor = 'rgba(18,18,18,.20)'; x.shadowBlur = 46; x.shadowOffsetY = 18;
    x.fillStyle = hex; x.fillRect(x0, y0, lt, ht);
    x.restore();

    // lumière rasante venue de la gauche, comme sur les photos
    var g = x.createLinearGradient(x0, y0, x1, y1);
    g.addColorStop(0, 'rgba(255,255,255,.14)');
    g.addColorStop(.5, 'rgba(255,255,255,0)');
    g.addColorStop(1, 'rgba(0,0,0,.12)');
    x.fillStyle = g; x.fillRect(x0, y0, lt, ht);

    // grain du lin
    var img = x.getImageData(x0, y0, lt, ht), d = img.data;
    for (var i = 0; i < d.length; i += 4) {
      var n = (Math.random() - .5) * 14;
      d[i] += n; d[i + 1] += n; d[i + 2] += n;
    }
    x.putImageData(img, x0, y0);

    // couture du volant plat \u2014 le repère visuel de l'emplacement « bord inférieur »
    var m = 0.052 * L;
    x.strokeStyle = 'rgba(0,0,0,.20)'; x.lineWidth = 2;
    x.strokeRect(x0 + m, y0 + m, lt - m * 2, ht - m * 2);

    return c.toDataURL('image/png');
  }

  /* ------------------------------------------------------------ interface */

  function construirePastilles(hote, liste, nomChamp, valeurInitiale, surChangement) {
    hote.innerHTML = '';
    liste.forEach(function (o) {
      var l = document.createElement('label');
      l.className = 'pastille';
      var fond = o.hex || (o.base ? 'linear-gradient(145deg,' + (o.reflet || o.base) + ',' + o.base + ')' : '#ccc');
      l.innerHTML =
        '<input type="radio" name="' + nomChamp + '" value="' + o.nom + '"' +
        (o.id === valeurInitiale ? ' checked' : '') + '>' +
        '<i style="background:' + fond + '"></i>' +
        '<span class="nom">' + o.nom + '</span>';
      l.querySelector('input').addEventListener('change', function () { surChangement(o.id); });
      hote.appendChild(l);
    });
  }

  function construireStyles() {
    var hote = $('#styles');
    var liste = B.STYLES;
    var exemple = etat.texte || 'Camille';
    hote.innerHTML = '';
    liste.forEach(function (s, i) {
      var choisi = (etat.style === s.id) || (i === 0 && !liste.some(function (t) { return t.id === etat.style; }));
      if (choisi) etat.style = s.id;
      var apercuTexte = s.casse === 'maj' ? exemple.toLocaleUpperCase('fr-FR') : exemple;
      var l = document.createElement('label');
      l.className = 'style-choix';
      /* Guillemets SIMPLES autour du nom de police : l'attribut style est
         délimité par des guillemets doubles, et JSON.stringify() en produirait
         qui le couperaient net — les aperçus retomberaient sur Inter. */
      var css = "font-family:'" + s.police + "'," + s.repli +
                ';font-weight:' + s.graisse +
                (s.approche ? ';letter-spacing:' + s.approche + 'em' : '');
      l.innerHTML =
        '<input type="radio" name="properties[Style]" value="' + s.nom + '"' + (choisi ? ' checked' : '') + '>' +
        '<span><em class="ex" style="' + css + '"></em>' +
        '<span class="lb">' + s.nom + '</span></span>';
      l.querySelector('.ex').textContent = apercuTexte;
      l.querySelector('input').addEventListener('change', function () {
        etat.style = s.id; rafraichir();
      });
      hote.appendChild(l);
    });

    /* Troisième case de la grille : pas une police, une porte de sortie vers
       WhatsApp pour un logo. Absente du HTML statique car elle ne doit
       jamais désynchroniser B.STYLES — construite ici, une fois, à côté des
       vraies polices. Pas de lien : grille repassée à 2 colonnes. */
    var waLogo = hote.dataset.waLogo;
    if (waLogo) {
      var tpl = document.getElementById('tpl-logo-glyphe');
      var a = document.createElement('a');
      a.className = 'style-choix style-choix--logo';
      a.href = waLogo;
      a.target = '_blank';
      a.rel = 'noopener';
      a.setAttribute('aria-label', 'Envoyer un logo à broder sur WhatsApp — ouvre WhatsApp dans un nouvel onglet');
      a.innerHTML = '<span><em class="ex ex-logo"></em><span class="lb">Logo</span></span>';
      if (tpl) a.querySelector('.ex-logo').innerHTML = tpl.innerHTML;
      hote.appendChild(a);
    } else {
      hote.classList.add('styles--2col');
    }
  }

  /* Les aperçus de style doivent suivre la saisie. On ne reconstruit pas le
     DOM à chaque touche : on ne remplace que le texte des trois exemples. */
  function majApercusStyles() {
    var liste = B.STYLES;
    var brut = etat.texte.trim() || 'Camille';
    var exemples = document.querySelectorAll('.style-choix .ex');
    for (var i = 0; i < exemples.length && i < liste.length; i++) {
      exemples[i].textContent = liste[i].casse === 'maj' ? brut.toLocaleUpperCase('fr-FR') : brut;
    }
  }

  /* ------------------------------------------------------------ validation */

  function evaluer() {
    var probs = [];

    var v = B.valider(etat.texte);
    if (!v.ok) probs.push({ champ: 'prenom', message: v.message });

    var v = varianteChoisie();
    if (v && v.dispo === false) {
      probs.push({ champ: 'variante', message: 'Cette combinaison est épuisée. Choisissez un autre coloris ou format.' });
    }

    // finesse de trait : avertissement, pas blocage
    var m = apercu.mesurer();
    if (m && !m.brodable) {
      probs.push({
        champ: 'style', avertissement: true,
        message: 'Ce texte est long pour le style choisi : le trait descend à ' +
                 m.traitMm.toFixed(1).replace('.', ',') + ' mm, en dessous du seuil de ' +
                 B.SEUIL_TRAIT_MM.toString().replace('.', ',') + ' mm que la machine peut broder. ' +
                 'Choisissez un style plus épais, ou l’atelier vous rappellera pour ajuster.'
      });
    }

    return probs;
  }

  /* ---------------------------------------------------------------- prix */

  /* RÈGLE N° 1 : la personnalisation est offerte et incluse dans le prix.
     Aucun supplément, jamais — l'emballage cadeau est offert lui aussi. */
  function prix() {
    var v = varianteChoisie();
    return v ? v.prix : MODELE.prixBase;
  }

  /* ------------------------------------------------------------ rafraîchir */

  function rafraichir() {
    apercu.definirEtat({
      texte: etat.texte,
      style: etat.style, fil: etat.fil, emplacement: etat.emplacement
    });
    apercu.rendreBientot();

    var probs = evaluer();
    var bloquants = probs.filter(function (p) { return !p.avertissement; });
    var avertis   = probs.filter(function (p) { return p.avertissement; });

    var champPrenom = probs.filter(function (p) { return p.champ === 'prenom'; })[0];
    $('#msg-prenom').textContent = (champTouche && champPrenom) ? champPrenom.message : '';

    var boite = $('#alerte');
    /* Les blocages qui ne sont rattachés à aucun champ visible doivent être
       expliqués dans l'encart d'alerte, sinon le bouton se désactive sans que
       le client comprenne pourquoi. */
    var aExpliquer = bloquants.filter(function (p) { return p.champ === 'variante'; });
    var aAfficher = aExpliquer.concat(avertis);
    if (aAfficher.length) { boite.hidden = false; boite.textContent = aAfficher[0].message; }
    else boite.hidden = true;

    majVariante();
    var p = prix();
    $('#prix').textContent = p;
    var bouton = $('#btn-panier'), incomplet = bloquants.length > 0;
    bouton.disabled = incomplet;
    /* Le libellé porte l'action attendue : tant que la personnalisation n'est
       pas faite, le bouton ne propose pas d'acheter — il demande de personnaliser.
       Le brief interdit toute action « sans personnalisation ». */
    bouton.innerHTML = incomplet
      ? 'Créer ma taie'
      : 'Ajouter au panier — <span id="prix-bouton">' + p + '</span>&nbsp;€';

    var props = proprietes();
    siPresent('#etat-encode', function (e) { e.value = props['_etat']; });
    siPresent('#debug-props', function (e) { e.textContent = JSON.stringify(props, null, 2); });

    var desc = etat.texte
      ? 'Aperçu de la taie ' + etat.coloris + ', texte brodé en fil ' + B.FILS[etat.fil].nom.toLowerCase() + '.'
      : 'Aperçu de la taie sans broderie.';
    siPresent('#apercu-desc', function (e) { e.textContent = desc; });
  }

  /* ------------------------------------------- Résolution de la variante */
  /* Le panier doit recevoir la variante RÉELLEMENT choisie. Sans cette
     résolution, le formulaire envoyait toujours la première variante du
     produit : choisir « Bordeaux / XL » dans le configurateur commandait
     « Sable / Standard ». */

  function coloris(id) {
    for (var i = 0; i < COLORIS.length; i++) if (COLORIS[i].id === id) return COLORIS[i];
    return COLORIS[0];
  }

  function varianteChoisie() {
    if (!VARIANTES.length) return null;
    var attendu = [coloris(etat.coloris).valeurOption];
    if (OPTION2) attendu.push(etat.option2);
    for (var i = 0; i < VARIANTES.length; i++) {
      var v = VARIANTES[i], ok = true;
      for (var j = 0; j < attendu.length; j++) {
        if (normaliser(v.options[j]) !== normaliser(attendu[j])) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function majVariante() {
    var v = varianteChoisie();
    var champ = $('#variante-id');
    if (v && champ) champ.value = v.id;
    return v;
  }

  /* --------------------------------------- ce qui part avec la commande */

  function proprietes() {
    var style = B.STYLES.filter(function (s) { return s.id === etat.style; })[0] || {};
    var o = {
      'Coloris': coloris(etat.coloris).nom,
      'Texte brodé': etat.texte,
      'Style': style.nom,
      'Couleur du fil': B.FILS[etat.fil].nom,
      'Emplacement': B.EMPLACEMENTS[etat.emplacement]
    };
    if (etat.cadeau) {
      o['Emballage cadeau'] = 'Oui';
      var m = $('#message-cadeau').value.trim();
      if (m) o['Message cadeau'] = m;
    }
    /* Propriété masquée (préfixe _) : invisible du client, lue par l'atelier.
       Elle contient tout l'état, ce qui permet de rejouer l'aperçu au pixel
       près même si l'envoi du PNG a échoué. */
    o['_etat'] = B.encoderEtat({
      v: 1, modele: MODELE.identifiant || 'taie-lin-lave', coloris: etat.coloris,
      texte: etat.texte,
      style: etat.style, fil: etat.fil, emplacement: etat.emplacement
    });
    return o;
  }

  /* ------------------------------------------------------------- démarrage */

  function changerColoris(id) {
    etat.coloris = id;
    var c = COLORIS.filter(function (o) { return o.id === id; })[0];
    /* Photo réelle si le bloc en porte une ; sinon l'aplat généré par le code,
       le temps que les photos fournisseur arrivent. */
    chargerFond(c, faceChargee).then(rafraichir);
  }

  /* Nom de champ SANS le préfixe "properties[" : le coloris est déjà une
     vraie option de variante Shopify (item.options_with_values l'affiche
     tout seul dans le panier). En "properties[Coloris]", il se retrouvait
     dupliqué à l'identique juste en dessous — "Coloris: Blanc" deux fois. */
  construirePastilles($('#coloris'), COLORIS, 'coloris-pastille', etat.coloris, changerColoris);

  var filsListe = Object.keys(B.FILS).map(function (k) {
    var f = B.FILS[k]; return { id: k, nom: f.nom, base: f.base, reflet: f.metallique ? f.reflet : null };
  });
  construirePastilles($('#fils'), filsListe, 'properties[Couleur du fil]', etat.fil, function (id) {
    etat.fil = id; rafraichir();
  });

  /* second choix du produit : format, taille… */
  if (OPTION2) {
    var bloc2 = $('#bloc-option2');
    bloc2.hidden = false;
    $('#legende-option2').textContent = OPTION2.nom;
    var hote2 = $('#option2');
    hote2.innerHTML = '';
    OPTION2.valeurs.forEach(function (valeur, i) {
      var l = document.createElement('label');
      l.className = 'segment';
      /* Même raison que pour le coloris : ce second choix (format, taille…)
         est déjà une option de variante Shopify, affichée par le panier.
         Pas de préfixe "properties[" ici pour ne pas la faire apparaître
         deux fois sur la ligne de commande. */
      l.innerHTML = '<input type="radio" name="option2-segment" value="' +
        valeur.replace(/"/g, '&quot;') + '"' + (valeur === etat.option2 ? ' checked' : '') + '><span></span>';
      l.querySelector('span').textContent = valeur;
      l.querySelector('input').addEventListener('change', function () {
        /* Changer de format change la PHOTO, pas seulement le prix : on
           recharge le fond avant de repeindre, sinon l'aperçu garde le
           rectangle en montrant le prix du carré. */
        var avant = cleFormat();
        etat.option2 = valeur;
        if (cleFormat() !== avant) {
          chargerFond(coloris(etat.coloris), faceDe(etat.emplacement)).then(rafraichir);
        } else {
          rafraichir();
        }
      });
      hote2.appendChild(l);
    });
  }

  if (OPTIONS.length) $('#legende-coloris').textContent = OPTIONS[0].nom;

  construireStyles();

  $('#prenom').addEventListener('input', function () {
    champTouche = true;
    etat.texte = this.value;
    $('#compteur').textContent = this.value.length + '/' + B.MAX_CARACTERES;
    $('#compteur').classList.toggle('limite', this.value.length >= B.MAX_CARACTERES);
    majApercusStyles();
    rafraichir();
  });


  Array.prototype.forEach.call(document.querySelectorAll('[data-emplacement]'), function (r) {
    r.addEventListener('change', function () {
      etat.emplacement = this.dataset.emplacement;
      var face = faceDe(etat.emplacement);
      if (face === faceChargee) { rafraichir(); return; }
      chargerFond(coloris(etat.coloris), face).then(rafraichir);
    });
  });

  $('#cadeau').addEventListener('change', function () {
    etat.cadeau = this.checked;
    $('#bloc-message').hidden = !this.checked;
    rafraichir();
  });
  $('#message-cadeau').addEventListener('input', rafraichir);

  /* loupe */
  var loupe = $('#loupe');
  siPresent('#btn-loupe', function (b) { b.addEventListener('click', function () {
      siPresent('#loupe-img', function (i) { i.src = apercu.exporterPNG(); });
    if (!loupe) return;
    if (loupe.showModal) loupe.showModal(); else loupe.setAttribute('open', '');
  }); });
  siPresent('#loupe-fermer', function (b) {
    b.addEventListener('click', function () { if (loupe) { loupe.close ? loupe.close() : loupe.removeAttribute('open'); } });
  });
  if (loupe) loupe.addEventListener('click', function (e) { if (e.target === loupe) loupe.close(); });

  /* export PNG */
  siPresent('#btn-png', function (b) {
    b.addEventListener('click', function () {
      var a = document.createElement('a');
      a.href = apercu.exporterPNG();
      a.download = 'pillowclub-apercu.png';
      a.click();
    });
  });

  /* Shopify poste les champs vides tels quels et l'atelier les retrouve sur
     la fiche de commande. Une ligne « Message cadeau : » vide, c'est une source
     d'erreur au poste de broderie. Un champ désactivé n'est pas posté : on
     coupe ce qui est vide juste avant l'envoi. */
  function nettoyerProprietes(form) {
    Array.prototype.forEach.call(
      form.querySelectorAll('[name^="properties["]'),
      function (el) {
        if (el.disabled || el.type === 'file') return;
        if (el.name.indexOf('properties[_') === 0) return;   /* champs techniques */
        if (el.type === 'checkbox' || el.type === 'radio') return;
        if (String(el.value).trim() === '') el.disabled = true;
      }
    );
  }

  var envoiEnCours = false;
  siPresent('#form-produit', function (f) { f.addEventListener('submit', function (e) {
    champTouche = true; rafraichir();

    if (MODE_DEMO) {
      e.preventDefault();
      alert('Démo — la commande partirait avec :\n\n' + JSON.stringify(proprietes(), null, 2));
      return;
    }
    if (envoiEnCours) return;          // deuxième passage : on laisse partir
    if ($('#btn-panier').disabled) { e.preventDefault(); return; }

    /* On joint le PNG de l'aperçu via un <input type="file"> natif : Shopify
       l'héberge et en attache l'URL à la ligne de commande. Si quoi que ce
       soit échoue ici, on laisse partir la commande quand même — la propriété
       « _etat » permet à l'atelier de rejouer l'aperçu au pixel près. */
    e.preventDefault();
    var form = this;
    var terminer = function () { nettoyerProprietes(form); envoiEnCours = true; form.submit(); };

    apercu.exporterBlob().then(function (blob) {
      if (!blob || typeof DataTransfer === 'undefined') return terminer();
      try {
        var dt = new DataTransfer();
        dt.items.add(new File([blob], 'apercu-pillowclub.png', { type: 'image/png' }));
        $('#apercu-fichier').files = dt.files;
      } catch (err) {
        console.warn('aperçu non joint, l’état encodé prend le relais', err);
      }
      terminer();
    }).catch(function (err) {
      console.warn('aperçu non joint, l’état encodé prend le relais', err);
      terminer();
    });
  }); });

  /* premier rendu : on attend les polices latines pour éviter un aperçu
     dessiné avec la police de repli, puis remplacé sous les yeux du client */
  /* L'aperçu ne doit JAMAIS rester vide : si la photo manque ou ne charge pas,
     on retombe sur l'aplat dessiné par le code. Un canevas blanc donnerait
     l'impression que le configurateur est cassé. */
  /* Le premier dessin doit être SYNCHRONE.
     rendreBientot() diffère le rendu à la frame suivante, ce qui est bon pour
     la frappe au clavier — mais au chargement, si cette frame ne vient pas
     (onglet en arrière-plan, page encore masquée), le canevas reste vide et le
     client croit le configurateur cassé : il faut qu'il clique une couleur
     pour que la taie apparaisse. On peint donc dès que la photo est là,
     sans attendre. */
  function poserFond(coloris) {
    recalibrer();
    apercu.rendre();
  }

  function chargerFond(coloris, face) {
    face = face || 'recto';
    var source = imageDe(coloris, face);
    var secours = function () {
      return apercu.definirFond(fabriquerTaie(coloris.hex || '#F0F0F4'));
    };
    var fini = function () { faceChargee = face; poserFond(coloris); };
    if (!source) return secours().then(fini);
    return apercu.definirFond(source)
      .then(fini)
      .catch(function (e) {
        console.warn('[Pillow Club] photo indisponible, repli sur l’aplat :', source, e);
        return secours().then(fini);
      });
  }

  Promise.all([ B.chargerPolices(), chargerFond(departColoris, faceDe(etat.emplacement)) ])
    .then(function () { rafraichir(); apercu.rendre(); })
    .catch(function (e) {
      console.error('[Pillow Club] démarrage du configurateur en échec :', e);
      apercu.definirFond(fabriquerTaie('#F0F0F4')).then(rafraichir);
    });
})();
